// Local SEO pages — each city has genuinely distinct local content (bâti,
// contraintes, contexte). No artificial keyword stuffing, no invented data.
import { PARIS_IMG, RAVALEMENT_IMG } from './serviceImages';

export const CITIES = [
  {
    slug: 'paris',
    path: '/renovation-paris',
    name: 'Paris',
    department: 'Paris (75)',
    image: PARIS_IMG,
    metaTitle: 'Rénovation, ravalement & isolation à Paris | VIREO',
    metaDescription:
      "Entreprise de rénovation à Paris : ravalement de façade, ITE, rénovation tous corps d’état, étanchéité et couverture. Intervention sur bâti haussmannien et copropriétés. Devis gratuit.",
    h1: 'Rénovation et ravalement de façade à Paris',
    primaryKeyword: 'ravalement façade Paris',
    secondaryKeywords: ['rénovation appartement Paris', 'entreprise rénovation Paris', 'façadier Paris'],
    intro:
      "VIREO intervient dans tout Paris pour le ravalement de façade, l’isolation par l’extérieur, la rénovation tous corps d’état, l’étanchéité et la couverture.",
    context: [
      "Le bâti parisien est marqué par les immeubles haussmanniens en pierre de taille, les façades en brique et un patrimoine dense en copropriété. Ces caractéristiques imposent des finitions soignées et, souvent, des enduits respectueux du bâti ancien.",
      "À Paris, le ravalement peut être encadré par des obligations de périodicité et, dans de nombreux secteurs, par des prescriptions patrimoniales. Nous intégrons ces contraintes et la logistique d’un chantier en milieu dense (échafaudage, voirie, copropriété) dès l’étude.",
    ],
    faq: [
      {
        q: 'Le ravalement est-il obligatoire à Paris ?',
        a: "À Paris, le ravalement de façade peut être rendu obligatoire selon une périodicité et des injonctions municipales. Nous faisons le point sur votre situation lors de la visite.",
      },
      {
        q: 'Intervenez-vous dans tous les arrondissements ?',
        a: "Oui, nous intervenons dans l’ensemble des arrondissements de Paris, pour les particuliers comme pour les copropriétés et les professionnels.",
      },
    ],
  },
  {
    slug: 'argenteuil',
    path: '/renovation-argenteuil',
    name: 'Argenteuil',
    department: 'Val-d’Oise (95)',
    image: RAVALEMENT_IMG,
    metaTitle: 'Rénovation & ravalement de façade à Argenteuil (95) | VIREO',
    metaDescription:
      "Entreprise de rénovation à Argenteuil : ravalement de façade, isolation extérieure, rénovation tous corps d’état et toiture. Maisons et copropriétés du Val-d’Oise. Devis gratuit.",
    h1: 'Rénovation et ravalement de façade à Argenteuil',
    primaryKeyword: 'rénovation Argenteuil',
    secondaryKeywords: ['ravalement façade Argenteuil', 'isolation extérieure Argenteuil'],
    intro:
      "À Argenteuil, VIREO réalise ravalements, isolation par l’extérieur, rénovations complètes et travaux de toiture pour les particuliers et les copropriétés.",
    context: [
      "Argenteuil associe un tissu pavillonnaire ancien — notamment des maisons en meulière — à des ensembles collectifs. Chaque type de bâti appelle des réponses différentes, du ravalement traditionnel à l’isolation thermique par l’extérieur.",
      "La rénovation énergétique y est un enjeu fort : nous proposons des solutions d’isolation, y compris biosourcées, adaptées au bâti existant du Val-d’Oise.",
    ],
    faq: [
      {
        q: 'Rénovez-vous les maisons en meulière ?',
        a: "Oui. Le bâti en meulière demande des finitions adaptées ; nous choisissons des enduits et traitements respectueux de ce type de façade.",
      },
      {
        q: 'Proposez-vous l’isolation extérieure à Argenteuil ?',
        a: "Oui, l’ITE est une solution pertinente pour de nombreuses maisons et immeubles d’Argenteuil. Nous l’étudions selon votre bâtiment.",
      },
    ],
  },
  {
    slug: 'gennevilliers',
    path: '/renovation-gennevilliers',
    name: 'Gennevilliers',
    department: 'Hauts-de-Seine (92)',
    image: RAVALEMENT_IMG,
    metaTitle: 'Rénovation & ravalement de façade à Gennevilliers (92) | VIREO',
    metaDescription:
      "Entreprise de rénovation à Gennevilliers : ravalement, isolation par l’extérieur, rénovation tous corps d’état, étanchéité. Logements collectifs et locaux. Devis gratuit.",
    h1: 'Rénovation et ravalement de façade à Gennevilliers',
    primaryKeyword: 'rénovation Gennevilliers',
    secondaryKeywords: ['ravalement façade Gennevilliers', 'entreprise ITE Gennevilliers'],
    intro:
      "VIREO accompagne les propriétaires et copropriétés de Gennevilliers pour le ravalement, l’isolation extérieure, la rénovation complète et l’étanchéité.",
    context: [
      "Gennevilliers, aux portes de Paris et le long de la Seine, présente un bâti mêlant logements collectifs, pavillons et anciens sites industriels reconvertis. Les façades d’immeubles y appellent souvent des ravalements d’ampleur et une isolation thermique.",
      "Pour les copropriétés, nous coordonnons les interventions avec le syndic et le conseil syndical, du chiffrage au suivi de chantier.",
    ],
    faq: [
      {
        q: 'Travaillez-vous avec les syndics de Gennevilliers ?',
        a: "Oui, nous répondons aux consultations de syndics et accompagnons les copropriétés sur toute la durée du projet.",
      },
      {
        q: 'Peut-on coupler ravalement et isolation ?',
        a: "Oui. Associer ravalement et ITE permet de mutualiser l’échafaudage et d’améliorer la performance thermique en une seule opération.",
      },
    ],
  },
  {
    slug: 'asnieres-sur-seine',
    path: '/renovation-asnieres-sur-seine',
    name: 'Asnières-sur-Seine',
    department: 'Hauts-de-Seine (92)',
    image: RAVALEMENT_IMG,
    metaTitle: 'Rénovation & ravalement de façade à Asnières-sur-Seine (92) | VIREO',
    metaDescription:
      "Entreprise de rénovation à Asnières-sur-Seine : ravalement de façade, rénovation tous corps d’état, isolation et toiture. Maisons de ville et immeubles anciens. Devis gratuit.",
    h1: 'Rénovation et ravalement de façade à Asnières-sur-Seine',
    primaryKeyword: 'rénovation Asnières-sur-Seine',
    secondaryKeywords: ['ravalement façade Asnières', 'rénovation maison Asnières'],
    intro:
      "À Asnières-sur-Seine, VIREO rénove maisons de ville et immeubles anciens : ravalement, rénovation complète, isolation et travaux de toiture.",
    context: [
      "Asnières-sur-Seine possède un patrimoine résidentiel marqué par des maisons de ville et des immeubles de la fin du XIXe et du début du XXe siècle, aux façades parfois ornementées. Leur rénovation demande un soin particulier des modénatures et des enduits.",
      "Nous adaptons nos procédés à ce bâti de caractère, en privilégiant des finitions compatibles avec les façades anciennes.",
    ],
    faq: [
      {
        q: 'Préservez-vous les ornements de façade ?',
        a: "Oui, nous reprenons les modénatures et éléments décoratifs pour conserver le caractère des façades anciennes d’Asnières.",
      },
      {
        q: 'Rénovez-vous les maisons de ville ?',
        a: "Oui, de la rénovation ponctuelle à la rénovation complète tous corps d’état, selon votre projet.",
      },
    ],
  },
  {
    slug: 'colombes',
    path: '/renovation-colombes',
    name: 'Colombes',
    department: 'Hauts-de-Seine (92)',
    image: RAVALEMENT_IMG,
    metaTitle: 'Rénovation & ravalement de façade à Colombes (92) | VIREO',
    metaDescription:
      "Entreprise de rénovation à Colombes : ravalement, isolation par l’extérieur, rénovation tous corps d’état et toiture. Pavillons meulière et copropriétés. Devis gratuit.",
    h1: 'Rénovation et ravalement de façade à Colombes',
    primaryKeyword: 'rénovation Colombes',
    secondaryKeywords: ['ravalement façade Colombes', 'isolation extérieure Colombes'],
    intro:
      "VIREO intervient à Colombes pour le ravalement, l’isolation extérieure, la rénovation complète et la toiture, auprès des particuliers et des copropriétés.",
    context: [
      "Colombes se caractérise par un important tissu pavillonnaire, notamment en meulière, complété par des copropriétés. Le ravalement et l’isolation y sont des travaux fréquents pour entretenir et valoriser le patrimoine bâti.",
      "Nous proposons des solutions d’isolation thermique adaptées, y compris biosourcées, dans la continuité de notre spécialité écologique.",
    ],
    faq: [
      {
        q: 'Intervenez-vous sur les pavillons de Colombes ?',
        a: "Oui, nous rénovons les maisons individuelles, dont le bâti en meulière, avec des finitions adaptées.",
      },
      {
        q: 'Quel délai pour un devis ?',
        a: "Après réception de votre demande et une visite, nous vous transmettons un devis gratuit dans les meilleurs délais.",
      },
    ],
  },
  {
    slug: 'montreuil',
    path: '/renovation-montreuil',
    name: 'Montreuil',
    department: 'Seine-Saint-Denis (93)',
    image: RAVALEMENT_IMG,
    metaTitle: 'Rénovation & ravalement de façade à Montreuil (93) | VIREO',
    metaDescription:
      "Entreprise de rénovation à Montreuil : rénovation tous corps d’état, ravalement, isolation et toiture. Bâti ancien, ateliers et immeubles. Devis gratuit.",
    h1: 'Rénovation et ravalement de façade à Montreuil',
    primaryKeyword: 'rénovation Montreuil',
    secondaryKeywords: ['rénovation appartement Montreuil', 'ravalement façade Montreuil'],
    intro:
      "À Montreuil, VIREO réalise rénovations complètes, ravalements, isolation et travaux de toiture, pour un bâti varié et souvent ancien.",
    context: [
      "Montreuil présente un bâti riche et contrasté : anciens ateliers, immeubles de faubourg, maisons et logements collectifs. Cette diversité se traduit par des projets de rénovation variés, du loft à la copropriété.",
      "Nous adaptons nos interventions à l’existant, en coordonnant l’ensemble des corps d’état lorsque le projet le nécessite.",
    ],
    faq: [
      {
        q: 'Rénovez-vous les anciens ateliers ?',
        a: "Oui, nous intervenons sur le bâti atypique de Montreuil en adaptant les techniques à la structure existante.",
      },
      {
        q: 'Gérez-vous l’ensemble des corps d’état ?',
        a: "Oui, en tant qu’entreprise générale nous coordonnons tous les lots avec un interlocuteur unique.",
      },
    ],
  },
  {
    slug: 'pantin',
    path: '/renovation-pantin',
    name: 'Pantin',
    department: 'Seine-Saint-Denis (93)',
    image: RAVALEMENT_IMG,
    metaTitle: 'Rénovation & ravalement de façade à Pantin (93) | VIREO',
    metaDescription:
      "Entreprise de rénovation à Pantin : ravalement, rénovation tous corps d’état, isolation et étanchéité. Bâti industriel réhabilité et immeubles anciens. Devis gratuit.",
    h1: 'Rénovation et ravalement de façade à Pantin',
    primaryKeyword: 'rénovation Pantin',
    secondaryKeywords: ['ravalement façade Pantin', 'rénovation immeuble Pantin'],
    intro:
      "VIREO intervient à Pantin pour le ravalement, la rénovation complète, l’isolation et l’étanchéité, sur un bâti ancien et des bâtiments réhabilités.",
    context: [
      "Aux portes de Paris, le long du canal de l’Ourcq, Pantin conjugue bâti industriel réhabilité, immeubles anciens et logements collectifs. Ces bâtiments appellent ravalements, isolations et reprises d’étanchéité.",
      "Pour les immeubles et copropriétés, nous assurons une coordination claire avec le syndic et un suivi de chantier rigoureux.",
    ],
    faq: [
      {
        q: 'Travaillez-vous sur les immeubles réhabilités ?',
        a: "Oui, nous intervenons aussi bien sur le bâti ancien que sur les bâtiments réhabilités de Pantin.",
      },
      {
        q: 'Traitez-vous les infiltrations de toiture-terrasse ?',
        a: "Oui, nous diagnostiquons et rénovons l’étanchéité des toitures-terrasses sujettes aux infiltrations.",
      },
    ],
  },
  {
    slug: 'pontoise',
    path: '/renovation-pontoise',
    name: 'Pontoise',
    department: 'Val-d’Oise (95)',
    image: RAVALEMENT_IMG,
    metaTitle: 'Rénovation & ravalement de façade à Pontoise (95) | VIREO',
    metaDescription:
      "Entreprise de rénovation à Pontoise : ravalement de façade, rénovation tous corps d’état, isolation et toiture. Bâti ancien et secteur patrimonial. Devis gratuit.",
    h1: 'Rénovation et ravalement de façade à Pontoise',
    primaryKeyword: 'rénovation Pontoise',
    secondaryKeywords: ['ravalement façade Pontoise', 'rénovation bâti ancien Pontoise'],
    intro:
      "À Pontoise, VIREO rénove le bâti ancien avec soin : ravalement, rénovation complète, isolation et travaux de toiture.",
    context: [
      "Pontoise, ville d’art et d’histoire, possède un centre ancien au bâti en pierre et des secteurs au patrimoine protégé. Les travaux de façade y requièrent des finitions traditionnelles et le respect des prescriptions applicables.",
      "Nous privilégions les enduits à la chaux et les techniques adaptées au bâti ancien, en tenant compte des contraintes patrimoniales locales.",
    ],
    faq: [
      {
        q: 'Respectez-vous les contraintes du secteur patrimonial ?',
        a: "Oui, nous adaptons nos finitions et procédés aux prescriptions applicables au bâti ancien et aux secteurs protégés de Pontoise.",
      },
      {
        q: 'Utilisez-vous des enduits à la chaux ?',
        a: "Oui, la chaux est souvent recommandée sur le bâti ancien car elle laisse respirer les murs. Le choix dépend du support.",
      },
    ],
  },
  {
    slug: 'cergy',
    path: '/renovation-cergy',
    name: 'Cergy',
    department: 'Val-d’Oise (95)',
    image: RAVALEMENT_IMG,
    metaTitle: 'Rénovation & ravalement de façade à Cergy (95) | VIREO',
    metaDescription:
      "Entreprise de rénovation à Cergy : ravalement, isolation par l’extérieur, rénovation tous corps d’état et toiture. Copropriétés et maisons. Devis gratuit.",
    h1: 'Rénovation et ravalement de façade à Cergy',
    primaryKeyword: 'rénovation Cergy',
    secondaryKeywords: ['ravalement façade Cergy', 'isolation extérieure Cergy'],
    intro:
      "VIREO intervient à Cergy pour le ravalement, l’isolation extérieure, la rénovation complète et la toiture, auprès des copropriétés et des particuliers.",
    context: [
      "Cergy, au cœur de l’agglomération de Cergy-Pontoise, compte un bâti principalement édifié entre les années 1970 et 1990 : copropriétés, logements collectifs et maisons. Ces bâtiments sont souvent concernés par des travaux de ravalement et d’amélioration thermique.",
      "L’isolation par l’extérieur y constitue un levier pertinent pour rénover les façades et améliorer le confort, en une seule opération.",
    ],
    faq: [
      {
        q: 'Accompagnez-vous les copropriétés de Cergy ?',
        a: "Oui, nous répondons aux consultations et coordonnons les travaux de ravalement et d’isolation avec le syndic.",
      },
      {
        q: 'L’ITE est-elle adaptée aux immeubles des années 1980 ?',
        a: "Souvent oui : l’ITE améliore le confort de ces bâtiments tout en rénovant la façade. Une étude précise le projet.",
      },
    ],
  },
];

export const getCityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
